import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { State } from './state'
import { Mutations } from './mutations'
import { ThreeMutationTypes as MutationTypes } from './mutation-types'
import { ThreeActionTypes as ActionTypes } from './action-types'

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ActionTypes.THREE_RESET]({ commit }: AugmentedActionContext, payload: boolean): void
  [ActionTypes.SET_SCENE_LOADED]({ commit }: AugmentedActionContext, payload: boolean): void
  [ActionTypes.SET_CONTROLS_ENABLED]({ commit }: AugmentedActionContext, payload: boolean): void

  [ActionTypes.SET_BAG_LOADED]({ commit }: AugmentedActionContext, payload: boolean): void
  [ActionTypes.SET_ANIMATION_FINISHED]({ commit }: AugmentedActionContext, payload: boolean): void

  [ActionTypes.SET_TEX_BODY]({ commit }: AugmentedActionContext, payload: string): void
  [ActionTypes.SET_TEX_DEFAULT_N]({ commit }: AugmentedActionContext, payload: string): void
  [ActionTypes.SET_TEX_BODY_N]({ commit }: AugmentedActionContext, payload: string): void
}

export const actions: ActionTree<State, RootState> & Actions = {
  [ActionTypes.THREE_RESET]({ commit }, payload: boolean) { commit(MutationTypes.THREE_RESET, payload); },
  [ActionTypes.SET_SCENE_LOADED]({ commit }, payload: boolean) { commit(MutationTypes.SET_SCENE_LOADED, payload); },
  [ActionTypes.SET_CONTROLS_ENABLED]({ commit }, payload: boolean) { commit(MutationTypes.SET_CONTROLS_ENABLED, payload); },

  [ActionTypes.SET_BAG_LOADED]({ commit }, payload: boolean) { commit(MutationTypes.SET_BAG_LOADED, payload) },
  [ActionTypes.SET_ANIMATION_FINISHED]({ commit }, payload: boolean) { commit(MutationTypes.SET_ANIMATION_FINISHED, payload) },

  [ActionTypes.SET_TEX_DEFAULT_N]({ commit }, payload: string) { commit(MutationTypes.SET_TEX_DEFAULT_N, payload) },
  [ActionTypes.SET_TEX_BODY]({ commit }, payload: string) { commit(MutationTypes.SET_TEX_BODY, payload) },
  [ActionTypes.SET_TEX_BODY_N]({ commit }, payload: string) { commit(MutationTypes.SET_TEX_BODY_N, payload) },
}
